import styled from 'styled-components';
import { injectOverlayShadow } from '../../utils/injectOverlayShadow';
function getPopoverPositionAdjustedStyles({ open, placement, tip, }) {
    const translationValue = `${open ? 8 : 0}px`;
    const marginValue = `${tip ? 12 : 0}px`;
    switch (placement) {
        case 'top':
            return `
        margin: ${marginValue} 0;
        transform: translateY(-${translationValue});
        `;
        case 'left':
            return `
        margin: 0 ${marginValue};
        transform: translateX(-${translationValue});
        `;
        case 'right':
            return `
        margin: 0 ${marginValue};
        transform: translateX(${translationValue});
        `;
        case 'bottom':
        default:
            return `
        margin: ${marginValue} 0;
        transform: translateY(${translationValue});`;
    }
}
function getArrowPosition({ placement }) {
    const margin = '-8px';
    const position = '100%';
    switch (placement) {
        case 'top':
            return `
        top: ${position};
        margin-left: ${margin};
      `;
        case 'left':
            return `
        left: ${position};
        margin-top: ${margin};
      `;
        case 'right':
            return `
        right: ${position};
        margin-top: ${margin};
      `;
        case 'bottom':
        default:
            return `
      bottom: ${position};
      margin-left: ${margin};
    `;
    }
}
function getArrowTransform({ placement }) {
    // Note: the translation is in part a fix and in part repositioning because
    // we're just rotating the canvas and the tip is centered on it with empty space around
    // https://stackoverflow.com/questions/44170229/how-to-prevent-half-pixel-svg-shift-on-high-pixel-ratio-devices-retina
    // The appropriate number is 8 but the additional pixel helps
    // avoiding a glitch on the outline focus in Chrome
    const displacement = '9px';
    switch (placement) {
        case 'top':
            return `transform: translate(0, -${displacement}) rotate(180deg)`;
        case 'left':
            return `transform: translate(-${displacement}, 0) rotate(90deg)`;
        case 'right':
            return `transform: translate(${displacement}, 0) rotate(270deg)`;
        case 'bottom':
        default:
            return `transform: translate(0, ${displacement}) rotate(0deg)`;
    }
}
export const StyledPopover = styled.div `
  box-sizing: border-box;
  /* Force the popover to maintain the container padding on both sides */
  max-width: calc(100% - ${(props) => props.containerPadding * 2}px);

  background-color: ${(props) => props.theme.colors.utility.neutral[0]};

  opacity: ${(props) => (props.open ? 1 : 0)};
  ${injectOverlayShadow}

  transition-timing-function: ${(props) => props.theme.easing};
  transition-duration: ${(props) => `${props.transitionDuration}ms`};
  transition-property: transform, opacity;

  ${() => getPopoverPositionAdjustedStyles}
`;
export const StyledPopoverContainer = styled.div `
  display: grid;
  grid-template-areas:
    '. . .'
    '. content .'
    '. . .';
  grid-template-rows: var(${(props) => props.theme.responsive.spacing.m}) 1fr var(
      ${(props) => props.theme.responsive.spacing.m}
    );
  grid-template-columns:
    var(${(props) => props.theme.responsive.spacing.m}) 1fr
    var(${(props) => props.theme.responsive.spacing.m});
  max-height: inherit;
`;
export const StyledPopoverBody = styled.div `
  grid-area: content;
  overflow-y: auto;
  overscroll-behavior: contain;
`;
export const StyledTip = styled.svg.attrs({
    ariaHidden: true,
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
}) `
  position: absolute;
  ${() => getArrowPosition}
  ${() => getArrowTransform}
`;
export const StyledTriangle = styled.polygon `
  fill: ${(props) => props.theme.colors.utility.neutral[0]};
`;
export const StyledVisuallyHiddenButton = styled.button.attrs({
    type: 'button',
    tabIndex: -1,
}) `
  position: absolute;

  width: 1px;
  height: 1px;
  margin: 0 -1px -1px 0;
  padding: 0;

  overflow: hidden;

  white-space: nowrap;

  border: 0;

  clip: rect(0 0 0 0);
  /* stylelint-disable plugin/no-unsupported-browser-features */
  clip-path: inset(50%);
`;
//# sourceMappingURL=Popover.styles.js.map